import { TreeSelect } from 'antd'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const TreeDiv = styled.div`
  .ant-select-tree .ant-select-tree-treenode {
    padding: 0 0 15px 0;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.GREY_T_20};
    text-transform: capitalize;
  }
  .ant-select-tree-list-holder {
    // max-height: 25vh !important;
    overflow-y: scroll !important;
  }
  .ant-select-tree-list-scrollbar-thumb {
    display: none !important;
  }
`
export const TreeSelectLocal = styled(TreeSelect)`
  width: 100%;
  margin-top: 10px;
  && .ant-select-selector {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }

  && .ant-select-selector:hover,
  && .ant-select-selector:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: ${props => (props?.height ? props?.height : '40px')};
    min-height: 40px;
    width: 100%;
    background: ${props =>
      props.white ? '#ffffff' : COLORS.PRIMARY_GREY_T_98};
    border: 1px solid #e6e7ea;
    border-radius: 10px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600px;
    &.ant-select-selection-placeholder {
      color: #676e83;
      font-size: 16px;
      font-weight: 600px;
    }
  }
`
